module.exports = __webpack_public_path__ + "static/media/prague_heat.57d945ec.gif";